import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import Axios from "../../api/Axios";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";

const DealerOutstandingSMS = () => {
    const GetAllOSRecords_URL = "/DealerOutstandingSMS/GetAllOSRecords?";
    const SaveOSData_URL = "/DealerOutstandingSMS/SaveOSData";
    const auth = storage.getLocal("user");

    const [loading, setLoading] = useState(false);
    const [osData, setOsData] = useState([]);
    const [selectedOS, setSelectedOS] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);

    const SendSMS = async () => {
        try{
            setLoading(true);
            const _objSaveOSDataModel = selectedOS.map((a)=>({
                MASK_PARTY_ID : a.MASK_PARTY_ID
            }));
            const obj = {
                CompId : auth.CompId,
                objSaveOSDataModel : _objSaveOSDataModel
            };
            console.log(obj,"SendSMS");
            const res = await Axios.post(SaveOSData_URL, JSON.stringify(obj));
            if(res.data.Status==="Success"){
                GetAllOSRecords();
                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setSelectedOS([]);
            }
        }catch(ex){
            console.log(ex);
        }finally{
            setLoading(false);
        }
    };
    const GetAllOSRecords = async () => {
        try{
            setLoading(true);
            const res = await Axios.get(`${GetAllOSRecords_URL}CompId=${auth.CompId}`);
            console.log(res.data,"GetAllOSRecords");
            setOsData(res.data.Data);
        }catch(ex){
            console.log(ex);
        }finally{
            setLoading(false);
        }
    };
    useEffect(()=>{
        GetAllOSRecords();
    },[]);

    if(loading){
        return(<Loader/>);
    }
    else{
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Dealer Outstanding SMS</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end mb-2">
                                <button type="button" className="btn btn-primary" onClick={()=>SendSMS()}>Send SMS <Fa.FaSms className='ms-2'/></button>
                            </div>
                        </div>
                    </div>
                
                    <section className="">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={osData}
                                    paginator
                                    // rows={10}
                                    filterDisplay="row"
                                    rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    scrollable
                                    stripedRows
                                    emptyMessage="No Record found"
                                    tableStyle={{ minWidth: "60rem" }}
                                    showSelectAll={true}
                                    selectAll={true}
                                    selectionMode="multiple"
                                    selection={selectedOS}
                                    onSelectionChange={(e) => {
                                        let selected = e.value || [];
                                        selected = selected.filter((row) => row.STATUS !== "CN");
                                        const currentSelectedIds = selectedOS.map(
                                            (row) => row.INVH_NO
                                        );
                                        const newSelectedIds = selected.map((row) => row.INVH_NO);
                                        const isSameSelection =
                                        currentSelectedIds.length === newSelectedIds.length &&
                                        currentSelectedIds.every((id) =>
                                            newSelectedIds.includes(id)
                                        );
                                        if (isSameSelection) {
                                            setSelectedOS([]);
                                        } else {
                                            setSelectedOS(selected);
                                        }
                                    }}
                                    onPage={(e) => {
                                        setFirst(e.first);
                                        setRows(e.rows);
                                        setSelectedOS([]);
                                    }}
                                    rows={rows}
                                    first={first}
                                    selectionPageOnly={true}
                                >
                                    <Column
                                        selectionMode='multiple'
                                        headerStyle={{ width: "6em" }}
                                        header="Select All"
                                    />
                                    <Column
                                        field="PARTY_CODE"
                                        header="Customer Code"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="PARTY_NAME"
                                        header="Customer Name"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="OUTSTANDING_AMNT"
                                        header="Outstanding Amount"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="PARTY_CONT_MOBILE"
                                        header="Customer Phone Number"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                </DataTable>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
};

export default DealerOutstandingSMS;